import React, { useEffect, useCallback, Fragment } from "react";
import { useParams } from "react-router-dom";
import AllMainTreatmentTr from "./AllMainTreatmentTr";
import baseUrl from "../../../../../api/baseUrl";
import AllSubTreatmentTr from "./AllSubTreatmentTr";

const Treatments: React.FC<any> = ({
  allTeatment,
  setallTeatment,
  handleAddSubTreatmentModal,
}) => {
  const { ID } = useParams<{ ID: string }>();

  const getData = useCallback(
    (id: string) => {
      baseUrl
        .get("treatment/find-treatment", {
          headers: { treatmentid: id },
        })
        .then((response) => {
          setallTeatment(response.data.data.treatment);
        })
        .catch((error) => {
          console.error("Error fetching treatment data:", error);
        });
    },
    [setallTeatment]
  );

  useEffect(() => {
    if (ID) {
      getData(ID);
    }
  }, [ID, getData]);

  const removediagnose = useCallback(
    (e: any) => {
      if (e._id) {
        setallTeatment((prevTreatments: any) =>
          prevTreatments.filter((treatment: any) => treatment._id !== e._id)
        );

        baseUrl
          .post(
            "treatment/remove-treatments",
            {},
            {
              headers: {
                treatmentid: ID,
                treatmentsid: e._id,
              },
            }
          )
          .then(() => {
          })
          .catch((error) => {
            console.error("Error removing treatment:", error);
          });
      } else {
        setallTeatment((prevTreatments: any) =>
          prevTreatments.filter((treatment: any) => treatment.tid !== e.tid)
        );
      }
    },
    [ID, setallTeatment]
  );

  const refresh = useCallback(() => {
    if (ID) {
      getData(ID);
    }
  }, [ID, getData]);

  return (
    <table className="w-full">
      <thead>
        <tr className="bg-slate-50 dark:bg-slate-700/50">
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Date</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Treatment</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Tooth No</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Surface</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Qty</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Price</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Status</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Dentist</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Note</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Action</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
        {allTeatment?.map((item: any, index: number) => (
          <Fragment key={index}>
            <AllMainTreatmentTr
              item={item}
              handleAddSubTreatmentModal={handleAddSubTreatmentModal}
              onClick={() => removediagnose(item)}
              refresh={refresh}
            />
            {item?.subTreatment?.length > 0 && (
              <tr>
                <td colSpan={10} className="p-0">
                  <div className="ml-8 my-2 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-200 dark:border-amber-700 overflow-hidden">
                    <div className="px-4 py-2 bg-amber-100 dark:bg-amber-900/30 border-b border-amber-200 dark:border-amber-700">
                      <h4 className="text-sm font-semibold text-amber-800 dark:text-amber-200">Case Treatment</h4>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full">
                        <thead>
                          <tr className="bg-amber-50/50 dark:bg-amber-900/20">
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Date</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Treatment</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Tooth No</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Surface</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Qty</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Price</th>  
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Status</th>  
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Dentist</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Note</th>
                            <th className="px-3 py-2 text-left text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase">Action</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-amber-100 dark:divide-amber-800/50">
                          {item?.subTreatment?.map((items: any, i: number) => (
                            <AllSubTreatmentTr
                              allTeatment={allTeatment}
                              setallTeatment={setallTeatment}
                              key={i}
                              items={items}
                              item={item}
                              paid={!item?.paid}
                              refresh={refresh}
                              _id={item?._id}
                            />
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </Fragment>
        ))}
      </tbody>
    </table>
  );
};

export default Treatments;
